export interface MangaChapter {
  id: string;
  title: string;
  updateDate: string;
  pageCount: number;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updateDate: string;
  chapters: MangaChapter[];
  featured?: boolean;
}

export const categories = [
  { slug: 'xiao-yuan', name: '校园', icon: 'ri-school-line', description: '青春校园纯爱故事' },
  { slug: 'gu-feng', name: '古风', icon: 'ri-ancient-gate-line', description: '唯美古风仙侠之恋' },
  { slug: 'qi-huan', name: '奇幻', icon: 'ri-magic-line', description: '奇幻异世界冒险' },
  { slug: 'xian-dai', name: '现代', icon: 'ri-building-line', description: '现代都市情感故事' },
  { slug: 'xuan-yi', name: '悬疑', icon: 'ri-search-eye-line', description: '悬疑推理扣人心弦' },
  { slug: 'qing-song', name: '轻松', icon: 'ri-emotion-happy-line', description: '轻松治愈甜蜜日常' },
  { slug: 're-xue', name: '热血', icon: 'ri-fire-line', description: '热血战斗激情澎湃' },
  { slug: 'ju-qing', name: '剧情', icon: 'ri-book-open-line', description: '深度剧情引人入胜' },
];

export const mangaList: Manga[] = [
  {
    id: 'manga-001',
    title: '星辰与你',
    author: '墨染青衣',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20handsome%20anime%20boys%20under%20starry%20night%20sky%2C%20soft%20romantic%20atmosphere%2C%20danmei%20BL%20manga%20cover%20art%20style%2C%20warm%20golden%20starlight%2C%20elegant%20school%20uniforms%2C%20cherry%20blossom%20petals%20floating%2C%20clean%20simple%20background%2C%20high%20quality%20illustration%20with%20soft%20lighting&width=600&height=800&seq=manga-cover-001&orientation=portrait',
    description: '高中二年级的沈星辰，遇到了转校生陆夜白。一个是安静内敛的学霸，一个是桀骜不驯的天才。两个截然不同的少年，在星空下的天文台相遇，从此命运的轨迹开始交错。青春、梦想、以及那份不敢说出口的心意，都在这个夏天悄然绽放。',
    category: 'xiao-yuan',
    tags: ['校园', '纯爱', '青春', '治愈'],
    status: '连载中',
    rating: 4.8,
    views: 1256800,
    favorites: 89600,
    updateDate: '2026-08-04',
    featured: true,
    chapters: [
      { id: 'ch-001-1', title: '第1话 星空下的相遇', updateDate: '2026-06-15', pageCount: 42 },
      { id: 'ch-001-2', title: '第2话 同桌的你', updateDate: '2026-06-22', pageCount: 38 },
      { id: 'ch-001-3', title: '第3话 午后的天台', updateDate: '2026-06-29', pageCount: 45 },
      { id: 'ch-001-4', title: '第4话 雨中的约定', updateDate: '2026-07-06', pageCount: 40 },
      { id: 'ch-001-5', title: '第5话 运动会的秘密', updateDate: '2026-07-13', pageCount: 44 },
      { id: 'ch-001-6', title: '第6话 夏日祭典', updateDate: '2026-07-20', pageCount: 50 },
      { id: 'ch-001-7', title: '第7话 烟花与告白', updateDate: '2026-07-27', pageCount: 48 },
      { id: 'ch-001-8', title: '第8话 新学期', updateDate: '2026-08-03', pageCount: 41 },
    ],
  },
  {
    id: 'manga-002',
    title: '凤求凰',
    author: '云浅月',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20style%20two%20handsome%20men%20in%20flowing%20robes%2C%20elegant%20danmei%20BL%20manga%20cover%2C%20traditional%20Chinese%20palace%20background%2C%20phoenix%20motif%2C%20soft%20ethereal%20atmosphere%2C%20peach%20blossoms%2C%20warm%20golden%20lighting%2C%20clean%20composition&width=600&height=800&seq=manga-cover-002&orientation=portrait',
    description: '大楚国运衰微，凤皇转世，栖于梧桐。文臣之首谢家嫡子谢瑾瑜，与武将世家出身的小将军萧长宁，在朝堂风云与天下纷争中相遇相知。一个是运筹帷幄的温润君子，一个是豪气干云的少年将军，共同守护这摇摇欲坠的江山。',
    category: 'gu-feng',
    tags: ['古风', '朝堂', '权谋', '仙侠'],
    status: '连载中',
    rating: 4.9,
    views: 2156000,
    favorites: 152300,
    updateDate: '2026-08-03',
    featured: true,
    chapters: [
      { id: 'ch-002-1', title: '第1话 金陵初见', updateDate: '2026-05-10', pageCount: 45 },
      { id: 'ch-002-2', title: '第2话 金殿对策', updateDate: '2026-05-17', pageCount: 42 },
      { id: 'ch-002-3', title: '第3话 边关告急', updateDate: '2026-05-24', pageCount: 48 },
      { id: 'ch-002-4', title: '第4话 出征', updateDate: '2026-05-31', pageCount: 50 },
      { id: 'ch-002-5', title: '第5话 沙场秋点兵', updateDate: '2026-06-07', pageCount: 46 },
      { id: 'ch-002-6', title: '第6话 锦书难托', updateDate: '2026-06-14', pageCount: 40 },
      { id: 'ch-002-7', title: '第7话 凯旋', updateDate: '2026-06-21', pageCount: 52 },
      { id: 'ch-002-8', title: '第8话 凤栖梧桐', updateDate: '2026-07-05', pageCount: 55 },
      { id: 'ch-002-9', title: '第9话 暗流涌动', updateDate: '2026-07-12', pageCount: 43 },
      { id: 'ch-002-10', title: '第10话 棋局', updateDate: '2026-07-19', pageCount: 47 },
      { id: 'ch-002-11', title: '第11话 宫变', updateDate: '2026-07-26', pageCount: 56 },
      { id: 'ch-002-12', title: '第12话 江山为聘', updateDate: '2026-08-02', pageCount: 60 },
    ],
  },
  {
    id: 'manga-003',
    title: '异世界咖啡厅',
    author: '七夜',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20attractive%20anime%20men%20in%20cozy%20fantasy%20cafe%20setting%2C%20danmei%20BL%20manga%20cover%20art%2C%20magical%20floating%20coffee%20cups%2C%20warm%20candlelight%2C%20witch%20and%20knight%20costumes%2C%20soft%20dreamy%20atmosphere%2C%20clean%20simple%20composition&width=600&height=800&seq=manga-cover-003&orientation=portrait',
    description: '普通上班族林墨意外穿越到剑与魔法的异世界，凭借一手精湛的咖啡技艺，在冒险者公会旁边开了一家小小的咖啡厅。没想到第一位客人，竟是传说中冷漠无情的S级冒险者——银发剑士艾德温。一杯手冲咖啡，拉开了这段跨越世界的奇妙缘分。',
    category: 'qi-huan',
    tags: ['奇幻', '异世界', '轻松', '治愈'],
    status: '连载中',
    rating: 4.7,
    views: 985000,
    favorites: 67200,
    updateDate: '2026-08-02',
    featured: true,
    chapters: [
      { id: 'ch-003-1', title: '第1话 穿越异世界', updateDate: '2026-06-20', pageCount: 40 },
      { id: 'ch-003-2', title: '第2话 第一位客人', updateDate: '2026-06-27', pageCount: 38 },
      { id: 'ch-003-3', title: '第3话 银发剑士', updateDate: '2026-07-04', pageCount: 42 },
      { id: 'ch-003-4', title: '第4话 特调咖啡', updateDate: '2026-07-11', pageCount: 36 },
      { id: 'ch-003-5', title: '第5话 冒险者的日常', updateDate: '2026-07-18', pageCount: 44 },
      { id: 'ch-003-6', title: '第6话 魔物来袭', updateDate: '2026-07-25', pageCount: 48 },
      { id: 'ch-003-7', title: '第7话 守护', updateDate: '2026-08-01', pageCount: 46 },
    ],
  },
  {
    id: 'manga-004',
    title: '总裁的秘密',
    author: '夜雨声烦',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20stylish%20anime%20men%20in%20modern%20office%20setting%2C%20danmei%20BL%20manga%20cover%2C%20one%20in%20suit%20one%20casual%2C%20city%20skyline%20through%20window%2C%20romantic%20tension%2C%20clean%20minimal%20background%2C%20warm%20evening%20light%2C%20professional%20illustration&width=600&height=800&seq=manga-cover-004&orientation=portrait',
    description: '刚毕业的苏然凭借出色的能力进入顶级企业盛华集团，却阴差阳错地成为了传闻中冷酷无情的总裁陆景琛的私人助理。朝夕相处间，他发现这位总裁并非表面那般冷漠，而陆景琛也在苏然的温暖中一点一点被融化。办公室里的秘密恋情，悄然上演。',
    category: 'xian-dai',
    tags: ['现代', '都市', '职场', '总裁'],
    status: '连载中',
    rating: 4.6,
    views: 1789000,
    favorites: 124500,
    updateDate: '2026-08-04',
    featured: true,
    chapters: [
      { id: 'ch-004-1', title: '第1话 面试', updateDate: '2026-06-01', pageCount: 38 },
      { id: 'ch-004-2', title: '第2话 第一天上班', updateDate: '2026-06-08', pageCount: 40 },
      { id: 'ch-004-3', title: '第3话 加班夜', updateDate: '2026-06-15', pageCount: 42 },
      { id: 'ch-004-4', title: '第4话 出差', updateDate: '2026-06-22', pageCount: 45 },
      { id: 'ch-004-5', title: '第5话 醉酒之后', updateDate: '2026-06-29', pageCount: 48 },
      { id: 'ch-004-6', title: '第6话 心意', updateDate: '2026-07-06', pageCount: 44 },
      { id: 'ch-004-7', title: '第7话 前女友', updateDate: '2026-07-13', pageCount: 46 },
      { id: 'ch-004-8', title: '第8话 危机', updateDate: '2026-07-20', pageCount: 50 },
      { id: 'ch-004-9', title: '第9话 坦白', updateDate: '2026-07-27', pageCount: 52 },
      { id: 'ch-004-10', title: '第10话 新的开始', updateDate: '2026-08-03', pageCount: 48 },
    ],
  },
  {
    id: 'manga-005',
    title: '深渊之眼',
    author: '墨香',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20mysterious%20anime%20men%20in%20dark%20atmospheric%20setting%2C%20danmei%20BL%20manga%20cover%20art%2C%20detective%20theme%2C%20one%20holding%20candle%2C%20gothic%20mansion%20background%2C%20suspenseful%20mood%2C%20deep%20shadows%2C%20clean%20composition%2C%20high%20contrast&width=600&height=800&seq=manga-cover-005&orientation=portrait',
    description: '刑警队长顾渊接手了一桩离奇的连环失踪案，所有线索都指向一座废弃多年的精神病院。在那里，他遇到了神秘的心理侧写师傅云深——一个似乎对案件了如指掌的盲眼青年。两人在深渊般的黑暗中摸索真相，却不知自己也正一步步踏入陷阱的中心。',
    category: 'xuan-yi',
    tags: ['悬疑', '推理', '犯罪', '心理'],
    status: '连载中',
    rating: 4.8,
    views: 1567000,
    favorites: 98500,
    updateDate: '2026-08-01',
    featured: true,
    chapters: [
      { id: 'ch-005-1', title: '第1话 失踪者', updateDate: '2026-07-01', pageCount: 42 },
      { id: 'ch-005-2', title: '第2话 废弃病院', updateDate: '2026-07-08', pageCount: 45 },
      { id: 'ch-005-3', title: '第3话 盲眼侧写师', updateDate: '2026-07-15', pageCount: 40 },
      { id: 'ch-005-4', title: '第4话 第一个线索', updateDate: '2026-07-22', pageCount: 48 },
      { id: 'ch-005-5', title: '第5话 深渊', updateDate: '2026-07-29', pageCount: 50 },
    ],
  },
  {
    id: 'manga-006',
    title: '猫与少年',
    author: '春日',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20cute%20anime%20boys%20with%20cats%20in%20sunny%20apartment%2C%20danmei%20BL%20manga%20cover%2C%20slice%20of%20life%20art%20style%2C%20warm%20sunlight%20through%20window%2C%20cozy%20atmosphere%2C%20soft%20pastel%20colors%2C%20clean%20composition%2C%20wholesome%20vibe&width=600&height=800&seq=manga-cover-006&orientation=portrait',
    description: '独自生活的插画师林悦，某天在家门口捡到了一只受伤的流浪猫。没想到第二天，一个自称是那只猫的银发少年出现在他面前，说要以人身报答他的救命之恩。从此，一人一猫（人？）开始了温馨又搞笑的同居生活。',
    category: 'qing-song',
    tags: ['轻松', '日常', '治愈', '搞笑'],
    status: '已完结',
    rating: 4.7,
    views: 890000,
    favorites: 56800,
    updateDate: '2026-07-15',
    chapters: [
      { id: 'ch-006-1', title: '第1话 雨夜的相遇', updateDate: '2026-04-01', pageCount: 35 },
      { id: 'ch-006-2', title: '第2话 猫少年', updateDate: '2026-04-08', pageCount: 38 },
      { id: 'ch-006-3', title: '第3话 同居第一天', updateDate: '2026-04-15', pageCount: 36 },
      { id: 'ch-006-4', title: '第4话 超市大作战', updateDate: '2026-04-22', pageCount: 40 },
      { id: 'ch-006-5', title: '第5话 喵星人的秘密', updateDate: '2026-04-29', pageCount: 38 },
      { id: 'ch-006-6', title: '第6话 生病', updateDate: '2026-05-06', pageCount: 42 },
      { id: 'ch-006-7', title: '第7话 告白', updateDate: '2026-05-13', pageCount: 45 },
      { id: 'ch-006-8', title: '第8话 永远在一起（完）', updateDate: '2026-05-20', pageCount: 50 },
    ],
  },
  {
    id: 'manga-007',
    title: '猎魔人传说',
    author: '火焰',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20powerful%20anime%20demon%20hunters%20in%20action%20pose%2C%20danmei%20BL%20manga%20cover%2C%20dark%20fantasy%20style%2C%20flaming%20swords%2C%20gothic%20cathedral%20background%2C%20dynamic%20composition%2C%20red%20and%20black%20color%20scheme%2C%20intense%20atmosphere&width=600&height=800&seq=manga-cover-007&orientation=portrait',
    description: '在这个妖魔横行的世界，猎魔人是最强的守护者。少年白夜为了寻找失踪的兄长，加入了最顶级的猎魔人组织"银翼"。他的搭档是组织中实力最强的猎魔人——冷酷孤傲的赤羽。两人一同踏上猎杀妖魔的征程，却发现真相远比想象中更加黑暗。',
    category: 're-xue',
    tags: ['热血', '战斗', '暗黑', '奇幻'],
    status: '连载中',
    rating: 4.5,
    views: 1320000,
    favorites: 78200,
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch-007-1', title: '第1话 银翼', updateDate: '2026-06-10', pageCount: 48 },
      { id: 'ch-007-2', title: '第2话 搭档', updateDate: '2026-06-17', pageCount: 45 },
      { id: 'ch-007-3', title: '第3话 初次任务', updateDate: '2026-06-24', pageCount: 52 },
      { id: 'ch-007-4', title: '第4话 魔都', updateDate: '2026-07-01', pageCount: 50 },
      { id: 'ch-007-5', title: '第5话 死斗', updateDate: '2026-07-08', pageCount: 56 },
      { id: 'ch-007-6', title: '第6话 觉醒', updateDate: '2026-07-15', pageCount: 54 },
      { id: 'ch-007-7', title: '第7话 真相的碎片', updateDate: '2026-07-22', pageCount: 48 },
      { id: 'ch-007-8', title: '第8话 兄长的踪迹', updateDate: '2026-07-29', pageCount: 50 },
    ],
  },
  {
    id: 'manga-008',
    title: '千年之恋',
    author: '浮生若梦',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20elegant%20anime%20men%20in%20traditional%20Chinese%20robes%2C%20one%20with%20long%20white%20hair%2C%20danmei%20BL%20manga%20cover%2C%20moonlit%20bamboo%20forest%2C%20immortal%20cultivation%20theme%2C%20ethereal%20atmosphere%2C%20soft%20silver%20moonlight%2C%20clean%20composition&width=600&height=800&seq=manga-cover-008&orientation=portrait',
    description: '千年修为的仙君白洛尘，为渡情劫下凡历练，化身为凡间的一名普通书生。他遇到了天真烂漫的小道士清玄，两人结伴游历人间。然而命运弄人，清玄正是千年前他亲手封印的魔尊转世。前世今生的纠葛，仙魔殊途的爱情，能否在这一世得到圆满？',
    category: 'gu-feng',
    tags: ['古风', '仙侠', '前世今生', '虐心'],
    status: '连载中',
    rating: 4.9,
    views: 2890000,
    favorites: 215600,
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch-008-1', title: '第1话 下凡', updateDate: '2026-05-01', pageCount: 45 },
      { id: 'ch-008-2', title: '第2话 小道士', updateDate: '2026-05-08', pageCount: 42 },
      { id: 'ch-008-3', title: '第3话 结伴同行', updateDate: '2026-05-15', pageCount: 44 },
      { id: 'ch-008-4', title: '第4话 妖市', updateDate: '2026-05-22', pageCount: 48 },
      { id: 'ch-008-5', title: '第5话 前世记忆', updateDate: '2026-05-29', pageCount: 52 },
      { id: 'ch-008-6', title: '第6话 封印', updateDate: '2026-06-05', pageCount: 50 },
      { id: 'ch-008-7', title: '第7话 觉醒', updateDate: '2026-06-12', pageCount: 55 },
      { id: 'ch-008-8', title: '第8话 正邪之争', updateDate: '2026-06-19', pageCount: 58 },
      { id: 'ch-008-9', title: '第9话 抉择', updateDate: '2026-06-26', pageCount: 60 },
      { id: 'ch-008-10', title: '第10话 天劫', updateDate: '2026-07-03', pageCount: 56 },
      { id: 'ch-008-11', title: '第11话 以命相护', updateDate: '2026-07-10', pageCount: 62 },
      { id: 'ch-008-12', title: '第12话 轮回', updateDate: '2026-07-17', pageCount: 54 },
      { id: 'ch-008-13', title: '第13话 重逢', updateDate: '2026-07-24', pageCount: 50 },
      { id: 'ch-008-14', title: '第14话 今生', updateDate: '2026-08-01', pageCount: 48 },
    ],
  },
  {
    id: 'manga-009',
    title: '画中仙',
    author: '风起天阑',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20man%20emerging%20from%20traditional%20Chinese%20painting%2C%20danmei%20BL%20manga%20cover%2C%20ink%20wash%20painting%20style%2C%20beautiful%20art%20student%20and%20mysterious%20man%2C%20soft%20ethereal%20colors%2C%20museum%20background%2C%20clean%20composition&width=600&height=800&seq=manga-cover-009&orientation=portrait',
    description: '美术学院学生季晚在一幅古画中，发现了一个被封印千年的画灵——名叫墨白的绝美男子。墨白请求季晚帮他寻找散落在世间各处的画卷碎片，以解开千年前的诅咒。而每一幅画中，都藏着一段他们前世的故事片段。',
    category: 'ju-qing',
    tags: ['剧情', '古风', '艺术', '前世今生'],
    status: '连载中',
    rating: 4.6,
    views: 765000,
    favorites: 45200,
    updateDate: '2026-07-30',
    chapters: [
      { id: 'ch-009-1', title: '第1话 无名古画', updateDate: '2026-06-15', pageCount: 40 },
      { id: 'ch-009-2', title: '第2话 画中人', updateDate: '2026-06-22', pageCount: 42 },
      { id: 'ch-009-3', title: '第3话 千年的诅咒', updateDate: '2026-06-29', pageCount: 38 },
      { id: 'ch-009-4', title: '第4话 第一幅碎片', updateDate: '2026-07-06', pageCount: 45 },
      { id: 'ch-009-5', title: '第5话 前世·初遇', updateDate: '2026-07-13', pageCount: 48 },
      { id: 'ch-009-6', title: '第6话 江南寻画', updateDate: '2026-07-20', pageCount: 44 },
      { id: 'ch-009-7', title: '第7话 第二幅碎片', updateDate: '2026-07-27', pageCount: 46 },
    ],
  },
  {
    id: 'manga-010',
    title: '我们的高中时代',
    author: '夏日微风',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20handsome%20anime%20high%20school%20boys%20in%20classroom%2C%20danmei%20BL%20manga%20cover%2C%20sunset%20light%20through%20windows%2C%20school%20desks%2C%20youthful%20romance%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=manga-cover-010&orientation=portrait',
    description: '高二分班后，话痨开朗的周小北和沉默寡言的班长顾言成为了同桌。一个是班里的开心果，一个是永远年级第一的高冷学霸。看似毫无交集的两人，在日常的点滴相处中，慢慢发现了彼此最真实的一面。那个夏天，他们的故事从一张课桌开始。',
    category: 'xiao-yuan',
    tags: ['校园', '青春', '纯爱', '日常'],
    status: '已完结',
    rating: 4.8,
    views: 1125000,
    favorites: 78900,
    updateDate: '2026-07-20',
    chapters: [
      { id: 'ch-010-1', title: '第1话 新同桌', updateDate: '2026-03-01', pageCount: 36 },
      { id: 'ch-010-2', title: '第2话 借笔记', updateDate: '2026-03-08', pageCount: 38 },
      { id: 'ch-010-3', title: '第3话 体育课', updateDate: '2026-03-15', pageCount: 40 },
      { id: 'ch-010-4', title: '第4话 放学后', updateDate: '2026-03-22', pageCount: 42 },
      { id: 'ch-010-5', title: '第5话 期中考', updateDate: '2026-03-29', pageCount: 38 },
      { id: 'ch-010-6', title: '第6话 文化祭', updateDate: '2026-04-05', pageCount: 46 },
      { id: 'ch-010-7', title: '第7话 台风天', updateDate: '2026-04-12', pageCount: 44 },
      { id: 'ch-010-8', title: '第8话 寒假', updateDate: '2026-04-19', pageCount: 48 },
      { id: 'ch-010-9', title: '第9话 情人节', updateDate: '2026-04-26', pageCount: 50 },
      { id: 'ch-010-10', title: '第10话 毕业（完）', updateDate: '2026-05-03', pageCount: 56 },
    ],
  },
  {
    id: 'manga-011',
    title: '夜行御史',
    author: '长安月',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20handsome%20anime%20men%20in%20ancient%20Chinese%20official%20robes%2C%20danmei%20BL%20manga%20cover%2C%20night%20scene%20with%20lanterns%2C%20mysterious%20detective%20theme%2C%20ancient%20city%20background%2C%20dramatic%20shadows%2C%20clean%20composition&width=600&height=800&seq=manga-cover-011&orientation=portrait',
    description: '京城接连发生命案，新任御史沈昭临危受命，必须在三个月内破案。唯一的线索指向一个神秘的江湖组织"夜行"。在追查过程中，沈昭结识了身份成谜的江湖侠客柳无尘。两人携手破案，却不知幕后黑手的真正目标，正是沈昭本人。',
    category: 'xuan-yi',
    tags: ['悬疑', '古风', '权谋', '推理'],
    status: '连载中',
    rating: 4.7,
    views: 1020000,
    favorites: 67400,
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch-011-1', title: '第1话 命案', updateDate: '2026-07-01', pageCount: 42 },
      { id: 'ch-011-2', title: '第2话 夜行', updateDate: '2026-07-08', pageCount: 40 },
      { id: 'ch-011-3', title: '第3话 侠客', updateDate: '2026-07-15', pageCount: 44 },
      { id: 'ch-011-4', title: '第4话 血字', updateDate: '2026-07-22', pageCount: 46 },
      { id: 'ch-011-5', title: '第5话 真凶', updateDate: '2026-07-29', pageCount: 50 },
    ],
  },
  {
    id: 'manga-012',
    title: '甜点师的恋爱魔法',
    author: '糖心',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20cute%20anime%20men%20in%20bakery%20shop%2C%20danmei%20BL%20manga%20cover%2C%20one%20holding%20cake%2C%20warm%20pastel%20colors%2C%20cozy%20patisserie%20interior%2C%20romantic%20sweet%20atmosphere%2C%20clean%20composition%2C%20soft%20lighting&width=600&height=800&seq=manga-cover-012&orientation=portrait',
    description: '梦想成为顶级甜点师的许甜甜，在巴黎学成归国后开了一家小小的法式甜品店。第一天营业就遇到了挑剔的美食评论家陆砚——一个对甜食深恶痛绝的男人。为了证明自己的实力，许甜甜接受了陆砚的挑战：做出能让他爱上甜食的甜点。一场甜蜜的较量就此开始。',
    category: 'qing-song',
    tags: ['轻松', '美食', '都市', '治愈'],
    status: '连载中',
    rating: 4.5,
    views: 678000,
    favorites: 38900,
    updateDate: '2026-08-01',
    chapters: [
      { id: 'ch-012-1', title: '第1话 甜品店开张', updateDate: '2026-07-01', pageCount: 36 },
      { id: 'ch-012-2', title: '第2话 挑剔的客人', updateDate: '2026-07-08', pageCount: 38 },
      { id: 'ch-012-3', title: '第3话 挑战', updateDate: '2026-07-15', pageCount: 40 },
      { id: 'ch-012-4', title: '第4话 马卡龙', updateDate: '2026-07-22', pageCount: 42 },
      { id: 'ch-012-5', title: '第5话 融化', updateDate: '2026-07-29', pageCount: 44 },
    ],
  },
];

export const getMangaById = (id: string): Manga | undefined => {
  return mangaList.find((m) => m.id === id);
};

export const getMangaByCategory = (slug: string): Manga[] => {
  return mangaList.filter((m) => m.category === slug);
};

export const getRelatedManga = (id: string, limit: number = 4): Manga[] => {
  const manga = getMangaById(id);
  if (!manga) return [];
  return mangaList
    .filter((m) => m.id !== id && (m.category === manga.category || m.tags.some((t) => manga.tags.includes(t))))
    .slice(0, limit);
};

export const getPopularManga = (limit: number = 8): Manga[] => {
  return [...mangaList].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestUpdates = (limit: number = 8): Manga[] => {
  return [...mangaList].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
};

export const getFeaturedManga = (): Manga[] => {
  return mangaList.filter((m) => m.featured);
};